import i18n from '@/i18n';
const Layout = () => import('@/layouts/main.vue');
const MarketplaceProductsLogs = () => import('./views/Index.vue');

export default [
  {
    path: '/marketplace-products-logs',
    component: Layout,
    meta: { authRequired: true, header: true, permission: 'superadmin|marketplaceadmin' },
    children: [
      {
        path: '',
        name: 'MarketplaceProductsLogs',
        component: MarketplaceProductsLogs,
        meta: { title: i18n.global.t('marketplaceLogs.products') },
      },
    ],
  },
];
